module.exports = __webpack_public_path__ + "static/media/EmotionalRegulationSystems.3418fb28.svg";